<div mat-dialog-content>
    <header>
        <div>Sales Channel</div>
    </header>

    <app-item-facebook 
    *ngIf="channel == 'facebook'"
    [item]="item"
    [defaults]="defaults"></app-item-facebook>
    
    <app-item-ebay 
    *ngIf="channel == 'ebay'"
    [item]="item"
    [defaults]="defaults"></app-item-ebay>
</div>